// src/services/memberStatusService.js
import api from "../api/api";

// GET semua member status
export const getAllMemberStatus = async () => {
  const res = await api.get("/member-statuses");
  return res.data.data; // sesuai struktur respons kamu
};

// CREATE member status baru
export const createMemberStatus = async (payload) => {
  const res = await api.post("/member-statuses", payload);
  return res.data;
};

// UPDATE member status berdasarkan ID
export const updateMemberStatus = async (id, payload) => {
  const res = await api.put(`/member-statuses/${id}`, payload);
  return res.data;
};

// DELETE member status berdasarkan ID
export const deleteMemberStatus = async (id) => {
  const res = await api.delete(`/member-statuses/${id}`);
  return res.data;
};
